import classNames from 'classnames';
import { Icon, IconProps } from '~/components/Icon/Icon';
import './Chevron.scss';

export type ChevronProps = IconProps & {
  direction?: 'right' | 'bottom' | 'left' | 'top';
  size?: 'small' | 'large';
  width?: number;
};

export const Chevron = ({ className, direction, size, width, ...props }: ChevronProps) => (
  <Icon
    className={classNames(
      'chevron',
      {
        [`chevron-direction-${direction}`]: direction,
        [`chevron-size-${size}`]: size,
      },
      className
    )}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    {...props}>
    <path
      d="M17.206 6.70703L18.126 7.62703L9.99999 15.752L1.87399 7.62703L2.79399 6.70703L9.99999 13.914L17.206 6.70703Z"
      stroke="currentColor"
      strokeWidth={width}
      fill="currentColor"
    />
  </Icon>
);
